import { once } from "~/jose_modern/once.js";
import { safeSubmitForm } from "~/jose_modern/auto_submit.js";

export function initEditTitle(container) {
  const editBtn = container.querySelector("[data-editable-title-edit]");
  if (!editBtn) return;

  once(editBtn, "editable-title", () => {
    const titleWrapper = editBtn.closest("[data-editable-title]");
    const h1 = titleWrapper.querySelector("h1");
    const form = titleWrapper.querySelector("[data-editable-title-form]");
    const input = titleWrapper.querySelector("[data-editable-title-input]");

    const showInput = () => {
      h1.classList.add("is-hidden");
      form.classList.remove("is-hidden");
      editBtn.classList.add("is-hidden");
      input.focus();
      input.select();
    };

    const submit = () => {
      if (input.value.trim() && input.value.trim() !== h1.textContent.trim()) {
        safeSubmitForm(form);
      } else {
        input.value = h1.textContent.trim();
        h1.classList.remove("is-hidden");
        form.classList.add("is-hidden");
        editBtn.classList.remove("is-hidden");
      }
    };

    editBtn.addEventListener("click", (e) => {
      e.preventDefault();
      showInput();
    });

    input.addEventListener("keydown", (ev) => {
      if (ev.key === "Enter") {
        ev.preventDefault();
        submit();
      }
      if (ev.key === "Escape") {
        input.value = h1.textContent.trim();
        h1.classList.remove("is-hidden");
        form.classList.add("is-hidden");
        editBtn.classList.remove("is-hidden");
      }
    });

    input.addEventListener("blur", submit);
  });
}
